import { createFileRoute, Outlet } from '@tanstack/react-router';

import { CustomerNavbar } from '@/components/customer-navbar';

export const Route = createFileRoute('/_public/customer/locations/$locationId/electrical/projects/$projectId')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <div className="flex flex-col min-h-screen max-h-screen">
            <CustomerNavbar isPublic />
            <div className="h-full w-full flex justify-center grow">
                <Outlet />
            </div>
        </div>
    );
}
